export const NOTES_MAX_LENGTH = {
    TITLE_MAX_LENGTH: 500,
    BODY_MAX_LENGTH: 20000,
};

export const SCREEN_SHARE_AVAILABILITY_TYPES = {
    offForAllParticipant: "0",
    availableForAllParticipant: "1",
    availableForHost: "2",
    availableForGuest: "3",
};

export const BROWSER = {
    CHROME: "chrome",
    FIREFOX: "firefox",
    MAC: "mac",
    EDGE: "edge",
    SAFARI: "safari",
};

export const SUPPORTED_BROWSER_VERSION = {
    CHROME: 100,
    ANDROID_CHROME: 109,
    ANDROID_SAMSUNG_CHROMIUM: 102,
    FIREFOX: 100,
    EDGE: 100,
    SAFARI: 13,
};

export const SUPPORTED_IOS_SAFARI = 13;
export const SUPPORTED_IOS_DEVICE = 13;
export const SUPPORTED_IOS_DEVICE_FOR_CHROME = 14.3;

export const CHAT_MSG_MAX_LENGTH = 3500;
